import { render, staticRenderFns } from "./top.vue?vue&type=template&id=70dc7687&scoped=true"
import script from "./_top.js?vue&type=script&lang=js&external"
export * from "./_top.js?vue&type=script&lang=js&external"
import style0 from "./_top.scss?vue&type=style&index=0&id=70dc7687&prod&lang=scss&scoped=true&external"
import style1 from "./top.vue?vue&type=style&index=1&id=70dc7687&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc7687",
  null
  
)

export default component.exports